export const DELETE_STATE = 'DELETE_STATE';
